import React, { Fragment } from "react";
import SpellingIcon from "../../../Assets/images/results_spelling.png";
import ListIcon from "../../../Assets/images/results_longago.png";
import RecentTimeIcon from "../../../Assets/images/results_recently.png";

function NoBreachesFound() {
    return (
        <Fragment>
            <div className="text-align-center">
                <h2 className="padding-vertical-m">We couldn't find any breaches matching the search.</h2>
                <h3 className="padding-bottom-m">Check out the tips below to find what you are looking for.</h3>
            </div>
            <div className="row breach-risk-card text-align-center">
                <div className="col-xs-12 col-md-3 no-result-card">
                    <h3 className="card-content-padding">Try different spelling variations</h3>
                    <img src={SpellingIcon} className="no-result-icon" alt='Blue circle with the letters "ABC" and a checkmark inside.' />
                    <p className="no-result-description card-content-padding text-align-left">
                        The organization may be spelled differently in our database. Try both the full name and any associated acronym.
                    </p>
                </div>
                <div className="col-xs-12 col-md-3 no-result-card">
                    <h3 className="card-content-padding">The breach may have occurred too long ago </h3>
                    <img src={ListIcon} className="no-result-icon" alt="Blue circle with a checklist and stopwatch inside." />
                    <p className="no-result-description card-content-padding text-align-left">
                        If the breach occurred before 2016, it may not be available in our database. As older breaches are being added regularly, please check back
                        soon.
                    </p>
                </div>
                <div className="col-xs-12 col-md-3 no-result-card">
                    <h3 className="card-content-padding">Did the breach occur recently?</h3>
                    <img src={RecentTimeIcon} className="no-result-icon" alt="Blue circle with a clock inside." />
                    <p className="no-result-description card-content-padding text-align-left">
                        Organizations that have recently experienced a breach may not have provided enough information about the breach to add it to our database
                        yet. Please check back soon.
                    </p>
                </div>
            </div>
        </Fragment>
    );
}

export default NoBreachesFound;
